import React from "react";
import clsx from "clsx/lite";

const ProductGallery = ({ verticalThumbsDesktop = false }) => (
	<div role="status"
		className={clsx("animate-pulse relative w-full md:pl-6 md:pr-4 justify-self-end",
			verticalThumbsDesktop
				? "lg:!w-[768px] lg:py-10 lg:pl-6 lg:max-w-full lg:aspect-[32/27] overflow-hidden"
				: "md:max-w-screen-sm "
		)}>
		<div className={clsx("flex gap-3 w-full flex-col items-baseline",
			verticalThumbsDesktop && "lg:flex-row-reverse lg:items-start")}>
			<div className="w-full">
				<div className="w-full bg-gray-100 dark:bg-gray-200 aspect-square" />
			</div>
			<div className={clsx("w-full px-8 relative", verticalThumbsDesktop && "lg:w-20 xl:!w-24 lg:flex lg:px-0")}>
				<div className={clsx("py-1 w-full flex max-h-52 md:px-10",
					verticalThumbsDesktop && "lg:flex-col lg:gap-2 lg:w-24 lg:max-h-full lg:px-0")}>
					{Array.from({ length: verticalThumbsDesktop ? 6 : 4 }).map((_, index) => (
						<div key={index} className={clsx("w-1/4 aspect-square mr-4 bg-gray-100 dark:bg-gray-200",
							verticalThumbsDesktop && "lg:w-20 xl:!w-24 even:hidden lg:even:block last:!block")} />
					))}
				</div>
			</div>
		</div>
		<span className="sr-only">Loading...</span>
	</div>
);
export default ProductGallery;